import { AnalyticsBrowser } from '@segment/analytics-next';
import { of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

import { throwClientLoadingError } from '@core/analytics-types';
import type {
  SegmentAPIMethods,
  SegmentClientIdentifyCallbackFn,
  SegmentClientOptions,
} from '@core/analytics-types';

export const loadAnalytics = (segmentKey: string, options?: SegmentClientOptions) => {
  const client = AnalyticsBrowser.load({ writeKey: segmentKey }, options);
  return of(segmentAdapter(client)).pipe(
    catchError(() => throwClientLoadingError()),
    shareReplay(1),
  );
};
const segmentAdapter = (input: AnalyticsBrowser): SegmentAPIMethods => ({
  ...input,
  identify: (
    userId?: number,
    traits?: Record<string, string | number>,
    options?: SegmentClientOptions,
    callback?: SegmentClientIdentifyCallbackFn,
  ) => {
    input.identify(`${userId}`, traits, options, callback);
  },
});
